import { SCREENING_STATUS } from "@/constants";

export default {
  screeningLoadInit(state, { query }) {
    state.result = null;
    state.status = SCREENING_STATUS.LOADING;
    state.error = null;
    state.query = query;
  },
  screeningLoadSuccess(state, { result }) {
    state.result = result;
    state.status = SCREENING_STATUS.LOAD_SUCCESS;
  },
  screeningLoadError(state, { error }) {
    state.error = error;
    state.status = SCREENING_STATUS.LOAD_ERROR;
  },
  screeningDetailsLoadInit(state) {
    state.details = null;
    state.error = null;
    state.status = SCREENING_STATUS.LOADING;
  },
  screeningDetailsSuccess(state, { details }) {
    state.details = details;
    state.status = SCREENING_STATUS.LOAD_SUCCESS;
  }
};
